export interface IResponseDbConfigData {
    patentCountries: PatentCountries;
}

export interface PatentCountries {
    major: ISelectData[];
    others: ISelectData[];
    ip5: ISelectData[];
}
export interface ISelectData {
    id: string | number;
    label: string;
    checked: boolean;
}

export interface PatentDbService {
    /**
     * 获取专利描述
     */
    getDbConfig(): Promise<IResponseDbConfigData>;
}

export const PatentDbService = Symbol.for('PatentDbService');
